import { initSliders } from "./sliders";
import { initSticky } from "./sticky-bar";
import { initContactForm } from "./contact-form";
document.addEventListener("DOMContentLoaded", function () {
  initSliders();
  initSticky();
  initContactForm();
});